import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sidebar', 'overlay']

  connect() {
    this.isOpen = false
  }

  open() {
    this.isOpen = true
    this.sidebarTarget.classList.remove('-translate-x-full')
    this.sidebarTarget.classList.add('translate-x-0')
    this.overlayTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden', 'lg:overflow-auto')
  }

  close() {
    this.isOpen = false
    this.sidebarTarget.classList.add('-translate-x-full')
    this.sidebarTarget.classList.remove('translate-x-0')
    this.overlayTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden', 'lg:overflow-auto')
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }
}
